export default __webpack_public_path__ + "static/media/download_p1.d68b430e.jpg";